import React, { use } from 'react';

import { createMobileNavClubStyle } from 'src/components/layout/mobile-nav/mobile-nav-helper';
import { SiteContext } from 'src/context/site-context';
import type { Styling } from 'src/context/styling';
import { useToggle } from 'src/custom-hooks/use-toggle';
import { clubNameDependingOnBuildTypeAndLanguage } from 'src/helpers/club-helper';

import HeaderChangeClub from '../header-change-club';
import HeaderClubSelect from '../header-club-select';

type MobileNavClubProps = {
  styling: Styling;
  clubName?: string;
  onFinish?: () => void;
};

const MobileNavClub: React.FC<MobileNavClubProps> = ({ styling, clubName, onFinish }) => {
  const [clubSelectExpanded, setClubSelectExpanded, , hideClubSelect] = useToggle(false);
  const { buildType, language } = use(SiteContext);
  const componentStyles = createMobileNavClubStyle(styling, buildType);
  const handleFinish = () => {
    onFinish?.();
    hideClubSelect();
  };

  return (
    <div css={{ width: '100%', padding: '0 1.5rem' }}>
      <div css={componentStyles.clubWrapperStyle}>
        {!!clubName && (
          <div css={componentStyles.clubNameStyle}>
            {clubNameDependingOnBuildTypeAndLanguage(clubName, buildType, language)}
          </div>
        )}
        <div css={componentStyles.headerWrapperStyle}>
          <HeaderChangeClub
            isClubSelectDropdownVisible={!!clubSelectExpanded}
            toggleClubSelectDropdown={setClubSelectExpanded}
          />
        </div>
      </div>

      {clubSelectExpanded && <HeaderClubSelect onFinish={handleFinish} />}
    </div>
  );
};

export default MobileNavClub;
